<template>
    <el-row class="vue-quill-editor">
        <quill-editor v-model="content" :options="editorOption" @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)" @change="onEditorChange($event)">

        </quill-editor>
    </el-row>
</template>
<script>
import Quill from 'quill' // 引入编辑器
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
import { ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { quillEditor } from 'vue-quill-editor'
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/ImageExtend', ImageExtend);
export default {
    components: {
        quillEditor
    },
    computed: {
        editor() {
            return this.$refs.myQuillEditor.quill;
        }
    },
    data() {
        return {
            content: '',
            editorOption: {
                modules: {
                    imageDrop: true, // 图片拖拽
                    imageResize: { // 放大缩小
                        displaySize: true
                    },
                    ImageExtend: { // 使用的图片上传扩展插件
                        name: 'file', // 传的参数名
                        size: 2, // 单位为M, 1M = 1024KB
                        action: process.env.VUE_APP_BASE_API + '/minio/fileUpload',
                        headers: (xhr) => {
                            xhr.setRequestHeader('Authorization', localStorage.getItem('jiadingFangwu_token'))
                        },
                        response: (res) => {
                            return process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + res.result;
                        }
                    },
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
                            // ['blockquote', 'code-block'], // 引用，代码块
                            [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
                            [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
                            [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
                            [{ 'direction': 'rtl' }], // 文本方向
                            [{ 'size': ['small', false, 'middle', 'large', 'huge'] }], // 字体大小
                            // [{ 'size': fontSize }], // 字体大小
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
                            [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
                            [{ 'font': ['SimSun', 'SimHei'] }], // 字体
                            [{ 'align': [] }], // 对齐方式
                            ['clean'], // 清除字体样式
                            ['image'] // 上传图片、上传视频
                        ], // 工具菜单栏配置
                        handlers: {
                            'image': function () { // 触发图片上传的时候返回的信息
                                QuillWatch.emit(this.quill.id) // 使用图片上传插件的统一写法
                            }
                        }
                    }
                },
                placeholder: '请在这里添加产品描述', // 提示
                readyOnly: false, // 是否只读
                theme: 'snow', // 主题 snow/bubble
                syntax: true // 语法检测
            },
        }
    },
    methods: {
        // 失去焦点
        onEditorBlur(editor) { },
        // 获得焦点
        onEditorFocus(editor) { },
        // 开始
        onEditorReady(editor) { },
        // 值发生变化
        onEditorChange(editor) {
            this.content = editor.html;
            this.$emit('handleQuillEditor', editor)
        },
    }
}
</script>
<style lang="scss">
    .vue-quill-editor {
        .ql-container.ql-snow{
        line-height: normal !important;
        width: 100%;
        height: 400px !important;
        font-size:14px;
    }
    }
</style>